import { render, staticRenderFns } from "./NoticeManage.vue?vue&type=template&id=01d7a5de&scoped=true&"
import script from "./NoticeManage.vue?vue&type=script&lang=js&"
export * from "./NoticeManage.vue?vue&type=script&lang=js&"
import style0 from "./NoticeManage.vue?vue&type=style&index=0&id=01d7a5de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d7a5de",
  null
  
)

export default component.exports